/*
  EBOLT x Searchanise. Searchanise draws the type-ahead dropdown and the
  /pages/search-results-page grid from its own index, so the theme's deal
  flags never reach them. This marks every product on a running deal with the
  same yellow flag the product cards use (the Deal entry's card-flag words,
  or "Free with a deal" on a deal's free item) and, in the dropdown, lists
  those products first.

  The deal list comes from /pages/milwaukee-deals?view=ebolt-dealmap
  (templates/page.ebolt-dealmap.liquid): fetched the first time a search
  result shows up, then kept in sessionStorage for ten minutes. Loaded by
  snippets/ebolt-snize.liquid, which also holds the styles.
*/
(function () {
  var me = document.currentScript;
  var mapUrl = me && me.getAttribute('data-dealmap');
  if (!mapUrl || !('MutationObserver' in window) || !window.fetch) return;

  var themeId = (window.Shopify && window.Shopify.theme && window.Shopify.theme.id) || '';
  var KEY = 'ebolt-dealmap3|' + themeId + '|' + mapUrl; // 3: the map also lists deals' free items
  var TTL = 10 * 60 * 1000;
  var flags = null;
  var loading = null;

  function load() {
    if (flags) return Promise.resolve(flags);
    if (loading) return loading;
    try {
      var cached = JSON.parse(window.sessionStorage.getItem(KEY) || 'null');
      if (cached && Date.now() - cached.t < TTL) {
        flags = cached.f || {};
        return Promise.resolve(flags);
      }
    } catch (e) {}
    loading = fetch(mapUrl, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : '{}'; })
      .then(function (text) {
        var data = null;
        try { data = JSON.parse(text); } catch (e) {}
        flags = (data && data.flags) || {};
        // only a map that parsed is kept, so a bad response is retried on the next page
        if (data) {
          try { window.sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), f: flags })); } catch (e) {}
        }
        return flags;
      })
      .catch(function () {
        flags = {};
        return flags;
      });
    return loading;
  }

  function productId(li) {
    var id = li.getAttribute('data-original-product-id');
    if (id) return id;
    return (li.id || '').replace('snize-ac-product-', '').replace('snize-product-', '');
  }

  // the yellow deal flag over the product photo
  function mark(li) {
    var flag = flags[productId(li)];
    li.setAttribute('data-ebolt-deal', flag ? 'yes' : 'no');
    if (!flag) return;
    li.classList.add('ebolt-snize-deal');
    var host = li.querySelector('.snize-thumbnail') || li.querySelector('.snize-thumbnail-wrapper');
    if (!host || host.querySelector('.ebolt-snize-flag')) return;
    var wrap = document.createElement('span');
    wrap.className = 'ebolt ebolt-snize-flag';
    var tag = document.createElement('span');
    tag.className = 'ebolt-flag ebolt-flag--deal';
    var words = document.createElement('span');
    words.textContent = flag;
    tag.appendChild(words);
    wrap.appendChild(tag);
    host.appendChild(wrap);
  }

  // dropdown only: deal products move to the front of their list, keeping their order
  function dealsFirst(list) {
    var items = Array.prototype.filter.call(list.children, function (el) {
      return el.matches('li.snize-product');
    });
    var isDeal = function (li) { return li.getAttribute('data-ebolt-deal') === 'yes'; };
    var deals = items.filter(isDeal);
    if (!deals.length || deals.length === items.length) return;
    var ordered = deals.concat(items.filter(function (li) { return !isDeal(li); }));
    var same = ordered.every(function (li, i) { return items[i] === li; });
    if (same) return;
    var marker = document.createComment('');
    list.insertBefore(marker, items[0]);
    var frag = document.createDocumentFragment();
    ordered.forEach(function (li) { frag.appendChild(li); });
    list.insertBefore(frag, marker);
    list.removeChild(marker);
  }

  var queued = false;
  function scan() {
    queued = false;
    if (!document.querySelector('li.snize-product:not([data-ebolt-deal])')) return;
    load().then(function () {
      var fresh = document.querySelectorAll('li.snize-product:not([data-ebolt-deal])');
      Array.prototype.forEach.call(fresh, mark);
      var lists = document.querySelectorAll('.snize-ac-results ul');
      Array.prototype.forEach.call(lists, function (ul) {
        if (ul.querySelector('li.snize-product')) dealsFirst(ul);
      });
    });
  }
  function queue() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(scan);
  }

  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  queue();
})();
